import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-google-private-conditions',
  templateUrl: './google-private-conditions.component.html'
})
export class GooglePrivateConditionsComponent implements OnInit {

  @ViewChild('acceptGoogle') modalGoogle: ModalDirective;
  @Output() socialSignIn = new EventEmitter();
  @Output() focusRegistro = new EventEmitter();
  constructor() {
  }

  ngOnInit(): void {
  }

  aceptarGoogle() {
    this.socialSignIn.emit(true);
    this.closeModal();
  }

  openModal() {
    this.modalGoogle.show();
  }

  closeModal() {
    this.focusRegistro.emit(true);
    this.modalGoogle.hide();
  }

}
